// @flow
import { toggleSearchResultsDialog } from 'actions/searchResultsDialog';

export const SHOW_ERROR_MESSAGE = 'errorMessage/SHOW';
export const HIDE_ERROR_MESSAGE = 'errorMessage/HIDE';

export function showErrorMessage(
  message,
  { playSound = false, severity = 'ERROR' } = {}
) {
  return {
    type: SHOW_ERROR_MESSAGE,
    message,
    playSound,
    severity,
  };
}

export function hideErrorMessage() {
  return (dispatch, getState) => {
    const {
      errorMessage: { severity },
    } = getState();

    // If the message originated from an error that occoured during storing a
    // search, close the results dialog when dismissing the snackbar
    if (severity === 'ERROR') {
      dispatch(toggleSearchResultsDialog(false));
    }

    dispatch({
      type: HIDE_ERROR_MESSAGE,
    });
  };
}



// WEBPACK FOOTER //
// ./actions/errorMessage.js